import React, { useState, useEffect } from 'react'
import WidgetItem from './features/WidgetItem';
import BottomWidgets from './features/bottomWidgets';
import { usePackingDefaultEditMutation, usePackingDefaultGetQuery, usePackingDefaultMutation } from '../../../../services/Api';
import { toast } from 'react-toastify';

const PackingListSetting = () => {
    const [packingDefaultEdit, { isLoading: editLoading }] = usePackingDefaultEditMutation()
    const [packingDefault, { isLoading }] = usePackingDefaultMutation()
    const { data, isLoading: packingLoading } = usePackingDefaultGetQuery()
    const [preId, setPreId] = useState(null)
    console.log("data", data)
    const [widgets, setWidgets] = useState([
        { type: "quickTrip", name: "My Quick Trip Bag", url: "", image: "", defaultType: "regular" },
        { type: "extraShoes", name: "Extra Shoes", url: "", image: "", defaultType: "regular" },
        { type: "travelOutfit", name: "Travel Outfit", url: "", image: "", defaultType: "regular" },
        { type: "toiletryKit", name: "Toiletry Kit", url: "", image: "", defaultType: "regular" },
        { type: "techKit", name: "Tech Kit", url: "", image: "", defaultType: "regular" },
        { type: "cameraKit", name: "Camera Kit", url: "", image: "", defaultType: "regular" },
        { type: "documents", name: "Documents", url: "", image: "", defaultType: "regular" },
        { type: "miscellaneousItems", name: "Miscellaneous Items", url: "", image: "", defaultType: "regular" },
        { type: "mediumCube", name: "Medium Cube", url: "", image: "", defaultType: "regular" },
        { type: "largeCube", name: "Large Cube", url: "", image: "", defaultType: "regular" },
    ]);

    const [widgetData, setWidgetData] = useState({
        laundryBag: {
            type: "pro",
            name: "compression",
            description: "",
            laundryBagImage: "",
            url: "",
        },
        travelPack: {
            type: "regular",
            size: "40L",
            travelPackImage: "",
            url: "",
            description: "",
        },
        dayPack: {
            type: "regular",
            size: "20L",
            dayPackImage: "",
            url: "",
            description: "",
        },
        hipPack: {
            type: "regular",
            size: "3L",
            hipPackImage: "",
            url: "",
            description: "",
        },

    });

    const handleSubmit = () => {
        const formData = {
            widgets: widgets,
            laundryBag: widgetData?.laundryBag,
            travelPack: widgetData?.travelPack,
            dayPack: widgetData?.dayPack,
            hipPack: widgetData?.hipPack,
        }
        if (data != undefined && data.length > 0) {
            packingDefaultEdit({ data: formData, id: preId })
                .unwrap()
                .then((payload) => {
                    if (payload.success) {
                        toast.success("Default Package Listing Added Successfully");

                    } else {
                        toast.error(payload?.message);
                    }
                })
                .catch((error) => {
                    toast.error(error?.data?.message);

                });
        } else {
            packingDefault({ data: formData })
                .unwrap()
                .then((payload) => {
                    if (payload.success) {
                        toast.success("Default Package Listing Added Successfully");

                    } else {
                        toast.error(payload?.message);
                    }
                })
                .catch((error) => {
                    toast.error(error?.data?.message);

                });
        }
    };

    useEffect(() => {
        if (data != undefined && data.length > 0) {
            const preData = data && data[0]
            setPreId(preData?._id)
            setWidgets(preData?.widgets)
            setWidgetData({
                laundryBag: preData?.laundryBag,
                travelPack: preData?.travelPack,
                dayPack: preData?.dayPack,
                hipPack: preData?.hipPack,
            })
        }
    }, [JSON.stringify(data)])

    console.log("data in widget", widgetData);
    return (
        <div>
            <div className='max-w-8xl !mx-auto space-y-6 bg-white p-8 mt-10' >
                <h2 className="text-left font-bold font-roboto-mono text-lg">
                    Default Settings
                </h2>
                <div className="flex items-center justify-between">
                    <WidgetItem widgets={widgets} setWidgets={setWidgets} />
                </div>
                <div className="">
                    <BottomWidgets widgetData={widgetData} setWidgetData={setWidgetData} />
                </div>

                <div className="flex justify-end gap-4 mt-4">

                    <button
                        onClick={handleSubmit}
                        className="px-4 py-2 bg-aths text-dark font-roboto-mono font-bold rounded" disabled={isLoading || editLoading} > {isLoading || editLoading ? "Saving..." : "Save"}</button>

                    {/* <button
                        // onClick={handleSubmit} 
                        className="px-4 py-2 bg-bgprimary text-dark font-roboto-mono font-bold rounded"  >Save and Change on all existing Packing lists </button> */}

                </div>

                {/* <div className="">
                     <pre className="mt-6 bg-gray-100 p-4 rounded text-sm overflow-auto">
                        {JSON.stringify(widgets, null, 2)}
                    </pre> 
                    <pre className="mt-6 bg-gray-100 p-4 rounded text-sm overflow-auto">
                        {JSON.stringify(widgetData, null, 2)}
                    </pre>
                </div> */}
            </div>
        </div>
    )
}

export default PackingListSetting
